import { useEffect, useRef } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";
import { isNativeOAuthCallbackUrl } from "@/lib/nativeOAuth";
import { safeAppUrl } from "@/lib/notificationRouting";

const NativeDeepLinkHandler = () => {
  const handledUrls = useRef(new Set<string>());
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const openNativeUrl = (url?: string | null) => {
      if (!url || handledUrls.current.has(url) || isNativeOAuthCallbackUrl(url)) return;
      handledUrls.current.add(url);

      const route = safeAppUrl(url);
      if (route.startsWith("/")) {
        navigate(route, { replace: false });
      }
    };

    void CapacitorApp.getLaunchUrl().then((launchUrl) => {
      openNativeUrl(launchUrl?.url);
    });

    const listener = CapacitorApp.addListener("appUrlOpen", ({ url }) => {
      openNativeUrl(url);
    });

    return () => {
      void listener.then((handle) => handle.remove());
    };
  }, [navigate]);

  return null;
};

export default NativeDeepLinkHandler;
